import { Controller } from "@hotwired/stimulus"
import "@teamshares/shoelace/dist/components/alert/alert.js"

const COPY_TOAST_DURATION_MS = 3000
const COPY_TOAST_TEXT = "Amount copied to clipboard."

export default class extends Controller {
  copy(event) {
    const target = event.currentTarget
    if (!target) return

    const value = target.dataset.invoiceCopyValue
    if (!value) return

    this.copyToClipboard(value)
      .then(() => this.showCopiedToast())
      .catch(() => this.showCopiedToast())
  }

  async copyToClipboard(value) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value)
      return
    }

    const textarea = document.createElement("textarea")
    textarea.value = value
    textarea.setAttribute("readonly", "readonly")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }

  showCopiedToast() {
    const toast = document.createElement("sl-alert")
    toast.variant = "success"
    toast.closable = true
    toast.duration = COPY_TOAST_DURATION_MS
    toast.textContent = COPY_TOAST_TEXT

    if (typeof toast.toast === "function") {
      document.body.appendChild(toast)
      toast.toast()
      return
    }

    this.showFallbackToast()
  }

  showFallbackToast() {
    let container = document.querySelector(".js-copy-toast-container")
    if (!container) {
      container = document.createElement("div")
      container.className = "flash-container js-copy-toast-container"
      document.body.appendChild(container)
    }

    const toast = document.createElement("div")
    toast.className = "flash flash-notice"
    toast.textContent = COPY_TOAST_TEXT
    toast.setAttribute("role", "status")
    toast.setAttribute("aria-live", "polite")

    container.appendChild(toast)
    setTimeout(() => {
      toast.remove()
      if (container.childElementCount === 0) container.remove()
    }, COPY_TOAST_DURATION_MS)
  }
}
